import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

type CreateCleanerDTO = {
  lat: number;
  lng: number;
  place: string;
  price: number;
  bio: string;
  slots: Record<
    number,
    { dayOfWeek: number; startTime: number; endTime: number }[]
  >;
};
export const createCleaner = async ({
  lat,
  lng,
  place,
  price,
  bio,
  slots,
}: CreateCleanerDTO) => {
  return await apiClient.post(ENDPOINTS.CLEANERS, {
    lat,
    lng,
    place,
    price,
    bio,
    slots,
  });
};
